import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";

import { errorSnack, infoSnack, successSnack } from "../snackbar/snackbarSlice";
import { fetchMyself } from "../users/usersSlice";


import api from "../../app/api";
import { uuidv4 } from "../../app/utils";
import baseURL from "../../app/utils.js";
import {withStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

export const ColorButton = withStyles((theme) => ({
    root: {
        margin: theme.spacing(3, 0, 2),
        backgroundColor: theme.palette.primaryButton.main,
        color: theme.palette.primaryButtonFont.main,
        width: "100%",
        borderRadius: "24px",
        "&:hover": {
            backgroundColor: theme.palette.primaryButton.main,
            opacity: 0.7,
        },
    },
}))(Button);

export const fetchUserPoints = createAsyncThunk(
  "userPoints/fetchUserPoints",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //  const response = await api.get(`${baseURL}v1/admin/users/wishlist?statuses=1,2&name=Sed&order_by=id&sort=asc&offset=0&limit=10`);
      const response = await api.get(
        `${baseURL}/v1/admin/users/${args.userID}/points`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        //localStorage.removeItem("clientUser");
        //localStorage.removeItem("clientToken");
      }
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
            "Error fetching Wishlist list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchUserPointsByClient = createAsyncThunk(
  "userPoints/fetchUserPointsByClient",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //  const response = await api.get(`${baseURL}v1/admin/users/wishlist?statuses=1,2&name=Sed&order_by=id&sort=asc&offset=0&limit=10`);
      const response = await api.get(
        `${baseURL}/v1/admin/points?order_by=redeemed&sort=desc`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        //localStorage.removeItem("clientUser");
        //localStorage.removeItem("clientToken");
      }
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
            "Error fetching Wishlist list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchUserPointsByProgram = createAsyncThunk(
  "userPoints/fetchUserPointsByProgram",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await api.get(
        `${baseURL}/v1/admin/programs/${args.programID}/points?order_by=redeemable&sort=desc`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        //localStorage.removeItem("clientUser");
        //localStorage.removeItem("clientToken");
      }
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
            "Error fetching Wishlist list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchUserPointsByPointsID = createAsyncThunk(
  "userPoints/fetchUserPointsByPointsID",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await api.get(
        `${baseURL}/v1/admin/users/${args.userID}/points_history/${args.pointsID}`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error fetching Store data"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const createPoints = createAsyncThunk(
  "userPoints/createPoints",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //full options
      const response = await api.post(
        `${baseURL}/v1/admin/users/${args.userID}/points`,
        args.pointsDetails,
        config
      );

      //update points in redux
      thunkAPI.dispatch(
        fetchUserPoints({
          token: args.token,
          userID: args.userID,
        })
      );

      //update user state (eg Points Balance)
      thunkAPI.dispatch(
        fetchMyself({
          token: args.token,
        })
      );

      thunkAPI.dispatch(
        successSnack(`${args.pointsDetails.points} added to member account`)
      );

      return await response;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error adding points"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const updatePoints = createAsyncThunk(
  "userPoints/updatePoints",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //full options
      const response = await api.patch(
        `${baseURL}/v1/admin/users/${args.userID}/points/${args.pointsID}`,
        args.pointsDetails,
        config
      );
      thunkAPI.dispatch(infoSnack("Account details updated successfully"));
      thunkAPI.dispatch(
        fetchMyself({
          token: args.token,
        })
      );

      return await response;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error updating Order"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const approvePoints = createAsyncThunk(
  "userPoints/approvePoints",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //full options
      const response = await api.patch(
        `${baseURL}/v1/admin/users/${args.userID}/points/${args.pointsID}/approve`,
        args.pointsDetails,
        config
      );
      // thunkAPI.dispatch(successSnack('Points updated'));
      thunkAPI.dispatch(infoSnack("Claim points approved"));

      return await response;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error updating Points"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const declinePoints = createAsyncThunk(
  "userPoints/approvePoints",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //full options
      const response = await api.patch(
        `${baseURL}/v1/admin/users/${args.userID}/points/${args.pointsID}/decline`,
        args.pointsDetails,
        config
      );
      // thunkAPI.dispatch(fetchOrders({token: args.token, query: '?limit=25'}));
      // thunkAPI.dispatch(successSnack('Order updated'));
      thunkAPI.dispatch(infoSnack("Claim points declined"));

      return await response;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error updating Order"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const purchasePoints = createAsyncThunk(
    "userPoints/purchasePoints",
    async (args, thunkAPI) => {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      try {
        //full options
        const response = await api.post(
            `${baseURL}/v1/admin/users/${args.userID}/manualpayments`,
            args.paymentDetails,
            config
        );

        // update points in redux
        thunkAPI.dispatch(
            fetchUserPoints({
              token: args.token,
              userID: args.userID,
            })
        );

        // update user state (eg Points Balance)
        thunkAPI.dispatch(
            fetchMyself({
              token: args.token,
            })
        );

        thunkAPI.dispatch(
            successSnack(`${args.pointsDetails.payment} added to member account`)
        );

        return await response;
      } catch (error) {
        if (error.response && error.response.data) {
          thunkAPI.dispatch(
              errorSnack(
                  error.response.data.error_description || "Error applying points purchase"
              )
          );
        }

        return thunkAPI.rejectWithValue({ error: error.message });
      }
    }
);


export const fetchUserPointsHistory = createAsyncThunk(
  "userPoints/fetchUserPointsHistory",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //full options
      const response = await api.get(
        `${baseURL}/v1/admin/users/${args.userID}/points_history?limit=25`,
        config
      );
      thunkAPI.dispatch(setPointsAmount(response.headers["x-total-count"]));
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error updating Order"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchMoreUserPoints = createAsyncThunk(
  "userPoints/fetchMoreUserPoints",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await api.get(
        `${baseURL}/v1/admin/users/${args.userID}/points?${args.query}&offset=${args.offset}`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        //localStorage.removeItem("clientUser");
        //localStorage.removeItem("clientToken");
      }
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
            "Error fetching additional points data"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const getFullUserPointsList = createAsyncThunk(
  "userPoints/getFullUserPointsList",
  async (args, thunkAPI) => {
    let objToMap = [];
    for (let i = 0; i < (args.targetLength - args.offset) / 100; i++) {
      objToMap.push({
        token: args.token,
        userID: args.userID,
        query: args.query,
        offset: args.offset + 100 * i,
      });
    }

    Promise.all(
      objToMap.map((requestData) =>
        thunkAPI.dispatch(fetchMoreUserPoints(requestData))
      )
    )
      .then((results) => { })
      .catch((err) => {
        return thunkAPI.rejectWithValue("Error fetching full points list");
      });
  }
);

export const fetchMoreUserPointsHistory = createAsyncThunk(
  "userPoints/fetchMoreUserPointsHistory",
  async (args, thunkAPI) => {
      const { token, userID, limit, page, append = true } = args;
      const offset = limit * page;
    try {
      const response = await api.get(
        `${baseURL}/v1/admin/users/${args.userID}/points_history`,
          {
              headers: { Authorization: `Bearer ${token}` },
              params: { limit, offset },
          }
      );
        return {
            data: response.data,
            //total: Number(response.headers["x-total-count"] ?? 0),
            //page,
            append: append ?? true,
        };
    } catch (error) {
        console.log(error)
      if (error.message.includes("401")) {
        //localStorage.removeItem("clientUser");
        //localStorage.removeItem("clientToken");
      }
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
            "Error fetching additional points history"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);


const userPointsSlice = createSlice({
  name: "userPoints",
  initialState: {
    pointsList: [],
    pointsHistory: [],
    memberPoint: {},
    loading: "idle",
    message: "",
    error: "",
    cart: [],
    createStatus: false,
    pointsAmount: ""
  },
  reducers: {
    addProductToCart(state, action) {
      state.cart = [...state.cart, action.payload];
      state.loading = "a";
    },
    removeProductFromCart(state, action) {
      state.cart = state.cart.filter(
        (prod) => prod[0].product.id !== action.payload
      );
      state.loading = "run";
    },
    setCreateStatus(state, action) {
      state.createStatus = action.payload;
    },
    setPointsAmount: (state, action) => {
      state.pointsAmount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUserPoints.pending, (state) => {
      state.pointsList = [];
      state.loading = "loading";
    });
    builder.addCase(fetchUserPoints.fulfilled, (state, { payload }) => {
      state.pointsList = payload;
      state.loading = "loaded";
    });
    builder.addCase(fetchUserPoints.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchUserPointsHistory.pending, (state) => {
      state.pointsHistory = [];
      state.loading = "loading";
    });
    builder.addCase(fetchUserPointsHistory.fulfilled, (state, { payload }) => {
      state.pointsHistory = payload;
      state.loading = "loaded";
    });
    builder.addCase(fetchUserPointsHistory.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchUserPointsByClient.pending, (state) => {
      state.pointsList = [];
      state.loading = "loading";
    });
    builder.addCase(fetchUserPointsByClient.fulfilled, (state, { payload }) => {
      state.pointsList = payload;
      state.loading = "loaded";
    });
    builder.addCase(fetchUserPointsByClient.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchUserPointsByProgram.pending, (state) => {
      state.pointsList = [];
      state.loading = "loading";
    });
    builder.addCase(
      fetchUserPointsByProgram.fulfilled,
      (state, { payload }) => {
        state.pointsList = payload;
        state.loading = "loaded";
      }
    );
    builder.addCase(fetchUserPointsByProgram.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchUserPointsByPointsID.pending, (state) => {
      // state.pointsList = [];
      state.loading = "loading";
    });
    builder.addCase(
      fetchUserPointsByPointsID.fulfilled,
      (state, { payload }) => {
        state.memberPoint = payload;
        state.loading = "loaded";
      }
    );
    builder.addCase(fetchUserPointsByPointsID.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(createPoints.pending, (state) => {
      state.createStatus = false;
    });
    builder.addCase(createPoints.fulfilled, (state, { payload }) => {
      state.createStatus = true;
    });
    builder.addCase(createPoints.rejected, (state, action) => {
      state.createStatus = false;
    });
    builder.addCase(fetchMoreUserPoints.fulfilled, (state, { payload }) => {
      state.error = "";
      state.pointsList = state.pointsList.concat(payload);
      state.loading = "loaded";
    });
    builder.addCase(fetchMoreUserPoints.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });

    builder.addCase(getFullUserPointsList.fulfilled, (state, { payload }) => {
      state.error = "";
      state.pointsList = state.pointsList.sort((a, b) => a.id - b.id);
      state.loading = "loaded";
    });
    builder.addCase(getFullUserPointsList.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });

    builder.addCase(fetchMoreUserPointsHistory.pending, (state, action) => {
      state.loading = "loading";
        // If replacing pointsHistory (pagination), clear first so UI doesn't flash old rows
        if (action.meta.arg?.append === false) {
            state.pointsHistory = [];
        }
    });
    builder.addCase(fetchMoreUserPointsHistory.fulfilled, (state, { payload }) => {
        const { data, append } = payload;
        // concat data for the Load More view, replace for pagination
        state.pointsHistory = append
            ? state.pointsHistory.concat(data) // Load More view
            : data;                            // Admin paginated view (replace)
      state.loading = "loaded";
        state.error = "";
    });
    builder.addCase(fetchMoreUserPointsHistory.rejected, (state, action) => {
      state.loading = "error";
        state.error = action.payload?.error || action.error.message || "Unknown error";
    });
  },
});

// Action creators are generated for each case reducer function
export const { setCreateStatus, setPointsAmount } = userPointsSlice.actions;

export const selectUserPoints = createSelector(
  (state) => ({
    userPoints: state.userPoints,
    pointsHistory: state.userPoints.pointsHistory,
    loading: state.userPoints.loading,
    error: state.userPoints.error,
    pointsList: state.userPoints.pointsList,
    memberPoint: state.userPoints.memberPoint,
    createStatus: state.userPoints.createStatus,
    pointsAmount: state.userPoints.pointsAmount
  }),
  (state) => state
);
export default userPointsSlice.reducer;
